// extracted by mini-css-extract-plugin
export default {"container":"UV-z","content":"VV-z","qrCodeWrapper":"WV-z","qrCode":"XV-z","printButton":"YV-z","printButtonIcon":"ZV-z","labelDescription":"_V-z"};